import Model from 'ln/model/Model';
import {Resolvable} from 'ln/components/Resolve';
import {Quiz as Question} from 'ln/lernfragen/quiz';
import {Quiz} from './Quiz';

import {Asset} from '../../Asset';

export class QuizQuestion extends Model implements Resolvable{

    public constructor(json: object) {
        super({
            text: '',
            image: null,
            question:null,
            toNext:false,
            quiz:null,
            nextDisabled:true,
            answerToggled:false,
            ...json
        });

        this.question.change.filter( d => d.name === 'inputState' ).subscribe(_ => this.nextDisabled = false );
    }

    public readonly text:string;
    public readonly image:Asset;
    public question:Question;
    public toNext:boolean;
    public nextDisabled:boolean;
    public answerToggled:boolean;
    public quiz:Quiz;

    public getViewName(): string {
        return 'QuizQuestion';
    }

    public nextQuestion(){
        if( this.question.inputState != 'none'  ) this.quiz.nextQuestion();
    }
}